import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Hero from 'common/Hero'
import HeroTitle from 'common/Hero/title'

import PageContent from 'common/PageContent'
import Section from 'common/Section'

import { setTitle } from 'reducers/global'

const Address = props => (
  <div className='overflow-auto dark-gray norms-16 mb3'>
    <h2 className='f5 mt0 mb1'>
      {props.title}
    </h2>
    <p className='mv0'>
      {props.address}
    </p>
  </div>
)

const Location = props => (
  <div className='flex flex-column flex-row-l mb5 ph4-xl ph6-xxl ph6-ll mh4-ll'>
    <div className='w-50-l'>
      <Link to={props.to} className='dark-gray no-underline underline-hover'>
        <h3 className='norms-24 fw5 mt0 st-mb3 pa0'>{props.name}</h3>
      </Link>
      <p className='ma0 mb4 norms-16 dark-gray'>{props.description}</p>
      <div className='flex flex-column st-mb3 pb3 mb0-l pb0-l'>
        {props.location.map(loc => (
          <div className='flex mb2' key={loc.title}>
            <div className='flex-none mr3'>
              <img src='assets/pin.png'
                style={{
                  height: 'auto',
                  width: '24px',
                }}
              />
            </div>
            <Address {...loc} />
          </div>
        ))}
      </div>
    </div>
    <Link to={props.to} className='flex items-center w-50-l'>
      <img className='flex-none' src={props.image} />
    </Link>
  </div>
)

const sgAddresses = [
  {
    title: 'Main Office',
    address: (
      <Fragment>
      100G Pasir Panjang Rd<br />
      #06-17<br />
      Interlocal Center<br />
      Singapore, 118523
      </Fragment>
    ),
  },
  {
    title: 'Style Theory Capsule',
    address: (
      <Fragment>
      313@Somerset #B1-38A<br />
      Singapore 238895
      </Fragment>
    ),
  },
]

const idAddresses = [
  {
    title: 'Main Office',
    address: (
      <Fragment>
      fX Sudirman<br />
      7th Floor<br />
      Jakarta, 10270
      </Fragment>
    ),
  },
  {
    title: 'Warehouse',
    address: (
      <Fragment>
      fX Sudirman<br />
      Level P4<br />
      Jakarta, 10270<br />
      </Fragment>
    ),
  },
]

class Locations extends React.Component {
  constructor (props) {
    super(props)
    props.dispatch(setTitle('Locations'))
  }

  render () {
    return (
      <div>
        <Hero style={{ backgroundColor: '#B8957D' }}>
          <HeroTitle>
            Locations
          </HeroTitle>
        </Hero>
        <PageContent>
          <Section>
            <Location to='/locations/singapore'
              name='Singapore'
              location={sgAddresses}
              image='https://d2u7nrdrppwhsn.cloudfront.net/career/location_sg.jpg'
            />
            <Location to='locations/jakarta'
              name='Jakarta'
              location={idAddresses}
              image='https://d2u7nrdrppwhsn.cloudfront.net/career/location_id.jpg'
            />
          </Section>
        </PageContent>
      </div>
    )
  }
}

export default connect()(Locations)
